import { useUserMetadata } from "../../hooks/useUserMetadata";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "../../components/ui/button";
import DarkModeToggle from "../../ui/DarkModeToggle";
import LogoutButton from "./LogoutButton";
import { useNavigate } from "react-router-dom";
import UserAvatar from "../../ui/UserAvatar";
import { useUiStore } from "@/stores/UiStore";
import { MessageCircleQuestion, Settings } from "lucide-react";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useSessionContext } from "supertokens-auth-react/recipe/session";
import { TrialState } from "@/utils/constants";
import * as Sentry from "@sentry/react";

function UserAvatarSidebar() {
  const session = useSessionContext();
  const isTrial = session.accessTokenPayload.isTrial;
  const paid_plan = session.accessTokenPayload?.paidPlan;

  const isTrialEligible =
    !session.loading &&
    session.doesSessionExist &&
    isTrial === TrialState.TRIAL_ELIGIBLE;
  const { data: user, isLoading } = useUserMetadata();
  const navigate = useNavigate();
  const sidebarExpanded = useUiStore((state) => state.sidebarExpanded);
  const posthog = usePostHog();
  var plan = "";
  if (session.accessTokenPayload.paidPlan) {
    if (user?.plan) {
      plan = user.plan;
    } else {
      plan = "Paid";
    }
  } else {
    plan = "Inactive";
  }
  var trial = "";
  if (isTrial === TrialState.TRIAL_ELIGIBLE) {
    trial = "Eligible";
  } else if (isTrial === TrialState.TRIAL_ACTIVE) {
    trial = "Active";
  } else {
    trial = "Inactive";
  }

  useEffect(() => {
    if (user?.email) {
      posthog?.identify(user.email, {
        user_id: session.userId,
        name: user?.name,
        email: user?.email,
        plan,
        trial,
        paid_plan,
      });
      Sentry.setUser({
        id: session.userId,
        username: user?.name,
        email: user?.email,
        plan,
        trial,
        paid_plan,
      });
    } else {
      posthog?.identify(session.userId, {
        user_id: session.userId,
        plan,
        trial,
        paid_plan,
      });
      Sentry.setUser({
        id: session.userId,
        plan,
        trial,
        paid_plan,
      });
    }
  }, [posthog, user, plan, session.userId, trial, paid_plan]);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex flex-1 gap-4 p-0">
          <span className="sr-only">Open menu</span>
          <UserAvatar user={user} isLoading={isLoading} className="scale-75" />
          {sidebarExpanded && <span className="text-sm ">{user?.name}</span>}
          {/* <MoreHorizontal className="h-4 w-4" /> */}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {!isTrialEligible && (
          <>
            <DropdownMenuItem>
              <DarkModeToggle />
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Button
                onClick={() => navigate("/support")}
                variant="ghost"
                className="flex flex-1 gap-4"
              >
                <MessageCircleQuestion />
                Support
              </Button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Button
                onClick={() => navigate("/settings")}
                variant="ghost"
                className="flex flex-1 gap-4"
              >
                <Settings />
                Settings
              </Button>
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuItem>
          <LogoutButton />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default UserAvatarSidebar;
